import { forwardRef } from 'react';

import { styled } from '@spazious/dollhouse-theme';

import { Typography, TypographyElement, TypographyProps } from '../Typography/index.js';

export type LinkButtonElement = TypographyElement;

export interface LinkButtonProps extends TypographyProps {}

export const LinkButton = styled(
  forwardRef<LinkButtonElement, LinkButtonProps>(({ children, ...restProps }, ref) => {
    return (
      <Typography aria-pressed="false" role="button" tabIndex={0} {...restProps} ref={ref}>
        {children}
      </Typography>
    );
  })
).withConfig({
  displayName: 'LinkButton',
})<LinkButtonProps>`
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;
